import { HOT_COLLECTIONS } from '@/mocks/chiliao';

export default function Collections() {
  return (
    <section id="hot" className="w-full scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-accent-500 pl-4 md:flex-row md:items-end md:justify-between md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-700">
              <i className="ri-bookmark-3-line text-sm" /> Curated Shelf
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              热门合集 · 本周在追
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            按人气排序的封面策展墙，每一组都是独立归档的合集。封面即入口，点进去就是整组完整列表。
          </p>
        </div>

        {/* 横向封面墙 */}
        <div className="mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-3 lg:gap-5">
          {HOT_COLLECTIONS.map((item) => (
            <article
              key={item.id}
              className="group w-44 shrink-0 snap-start overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 sm:w-52 lg:w-56"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={item.src}
                  alt={`51吃料 热门合集 · ${item.name}`}
                  title={`51吃料 热门合集 · ${item.name}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 inline-flex h-8 items-center gap-1 rounded-full bg-background-50/90 px-2.5 text-xs font-bold text-foreground-950 backdrop-blur">
                  {String(HOT_COLLECTIONS.indexOf(item) + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex flex-col gap-1 p-3 md:p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
                <div className="mt-1 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">合集</span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-700">
                    <i className="ri-chat-3-line text-sm text-accent-600" />
                    {item.comments.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}